import React, { useEffect, useState } from 'react';
import { getAllFeedbacks,getAllExaminerFeedbacks} from '../../services/feedbackService';

import { Link, useLocation } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';
import axiosInstance from '../../api/axios';
import CommentSection from "./CommentSection"; 




export const FeedbackList=()=> {
    const examinerId=parseInt(localStorage.getItem('examinerId'),10);
    const [feedbacks, setFeedbacks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedRow, setExpandedRow] = useState(null);
    const location = useLocation();

    const fetchFeedbacks = async () => {
        try {
            var data;
            var sharedFeedbacks;
            if(examinerId) {
                data = await getAllExaminerFeedbacks(examinerId);
                sharedFeedbacks = data.data.filter(f => f.share_to_student === true);
            }
            else {
                data = await getAllFeedbacks();

            sharedFeedbacks = data.data; 
              //  sharedFeedbacks = data.data.filter(f => f.share_to_student === true);
            }

    setFeedbacks(sharedFeedbacks);
            //console.log(data);
            //setFeedbacks(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    // Load feedbacks on component mount
    useEffect(() => {
        fetchFeedbacks();
    }, []);

    const toggleRowExpansion = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
    };
    
    const formatColumnData = (value) => {
        if (!value) return value;
    
        // Insert space before each uppercase letter
        let result = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    
        // Capitalize the first letter
        result = result.charAt(0).toUpperCase() + result.slice(1);
    
        return result;
    };
    
 
    // Transform the data for a specific column
    const transformColumnData = (rows) => {
        return rows.map(row => ({
            ...row,
            type: formatColumnData(row.type) // Only format this column
        }));
    };
    
    // Transform the rows before rendering
    const transformedRows = transformColumnData(feedbacks);
    const columns = React.useMemo(
        () => [
            { field: 'thesis_title', headerName: 'Thesis title', width: 170 },
            { field: 'student_name', headerName: 'Student', width: 120 },
            { field: 'enrollment_number', headerName: 'Enrollment No', width: 120 },
            // { field: 'mentor1_name', headerName: 'Mentor1', width: 120 },
            // { field: 'mentor2_name', headerName: 'Mentor2', width: 120 },
            ...(!examinerId ? [{ field: 'examiner_name', headerName: 'Examiner/Reviewer', width: 120 }] : []),
            { field: 'type', headerName: 'Type', width: 150 },
            {
                field: "expand",
                headerName: "Feedbacks",
                width: 150,
                renderCell: (params) => (
                    <button onClick={() => toggleRowExpansion(params.row.id)}>
                        {expandedRow === params.row.id ? "Collapse" : "Expand"}
                    </button>
                ),
            },
            { field: 'grade_overall', headerName: 'Grade', width: 120 },
            // { field: 'presentation_feedback', headerName: 'Presentation Feedback', width: 180 },
            // { field: 'report_feedback', headerName: 'Report Feedback', width: 180 },
            // { field: 'other_feedback', headerName: 'Other Feedback', width: 180 },
            // { field: 'overall_feedback', headerName: 'Feedback', width: 150 }
        ],
        [expandedRow]
    );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Action", width:300,
        renderCell:(params)=>{
            const { id, share_to_student } = params.row;
            //console.log(id)
            return(
                <div className="cellAction">
                    <div className="viewButton"><Link to={`/feedbacks/view-feedback/${id}`}state={{ from: location.pathname }}>View</Link></div>
                    {!share_to_student&&<div className="editButton"><Link to={`/feedbacks/edit-feedback/${id}`}state={{ from: location.pathname }}>Edit</Link></div>}
                    {!share_to_student&&<div className="editButton"><Link to={`/feedbacks/edit-feedback/${id}`}state={{ from: location.pathname }}>Edit</Link></div>}
                    {share_to_student && <div className="editButton">Feedback Shared with Student</div>}
                        </div>              
            );
        }
    }]

     const finalColumns = columns.concat(actionColumn).concat([
          {
            field: "comments",
            headerName: "Comments (communicate with student)",
            width: 500,
            renderCell: (params) => {
              const submissionId = params.row.thesis_status_id;
              const senderId = localStorage.getItem("userId");
              //console.log(examinerId)
              return <CommentSection submissionId={submissionId} senderId={senderId} />;
            }
          }
        ]);

    return (
        <div className="datatable" >
        {!examinerId && <div className="datatableTitle">


          <Link to="/feedbacks/new" className="link" >
          Add Feedback
          </Link>

        </div>}
      
      <DataGrid 
      rows={transformedRows}
      columns={finalColumns}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
    {expandedRow && (
    <div className="expanded-content" style={{ padding: "10px", background: "#f5f5f5" }}>
        <strong>Presentation Feedback:</strong> {feedbacks.find(fb => fb.id === expandedRow)?.presentation_feedback} <br />
        <strong>Report Feedback:</strong> {feedbacks.find(fb => fb.id === expandedRow)?.report_feedback} <br />
        <strong>Other Feedback:</strong> {feedbacks.find(fb => fb.id === expandedRow)?.other_feedback} <br />
        <strong>Overall Feedback:</strong> {feedbacks.find(fb => fb.id === expandedRow)?.overall_feedback}
    </div>
)}
  </div>


    );
}
